import { useMutation } from '@tanstack/react-query'
import { updateEarningsDistribution } from 'services/RewardsService'
import {
  type EarningsDistributionResponse,
  type UpdateEarningsDistributionRequest,
} from 'types/rewards'

export const useUpdateEarningsDistributionMutation = () =>
  useMutation<EarningsDistributionResponse, Error, UpdateEarningsDistributionRequest>({
    mutationFn: updateEarningsDistribution,
  })
